import { Document } from '@roc/feature-types';
import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { EscrowDepositCalculator } from '@roc/feature-escrow-deposit-calculator';
import { useStore } from '@roc/client-portal-shared/hooks';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type TaxEscrowDialogProps = {
  open?: boolean;
  onClose?: () => void;
  loan: any;
  document: Document;
  refreshLoan?: () => void;
};

export const TaxEscrowDialog = observer((props: TaxEscrowDialogProps) => {
  const { open, onClose, loan, document, refreshLoan } = props;
  const taskId = document?.taskId;
  const { escrowDepositCalculatorStore } = useStore();

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          maxWidth="lg"
          title='Tax Escrow'
          handleClose={onClose}
          dialogContent={
            <EscrowDepositCalculator
              store={escrowDepositCalculatorStore}
              loanId={loan?.loanId}
              loanTaskId={document?.loanTaskId}
              document={document}
              refreshAndClose={() => {
                onClose();
                refreshLoan();
              }}
            />
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          maxWidth="lg"
          handleClose={onClose}
          dialogContent={
            <EscrowDepositCalculator
              store={escrowDepositCalculatorStore}
              loanId={loan?.loanId}
              loanTaskId={document?.loanTaskId}
              document={document}
              refreshAndClose={() => {
                onClose();
                refreshLoan();
              }}
            />
          }
          removeContentBox
        />
      )}
    </>
  );
});

export default TaxEscrowDialog;